import {Component, OnInit} from '@angular/core';
import {AppStateService} from "./providers/app-state.service";
import {UserAuthData} from "./models/user-auth-data.model";
import {CommonUtils} from "./utils/common";
import {AuthService} from "./providers/auth.service";
import {Network} from "@capacitor/network";
import {Storage} from "@ionic/storage-angular";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent{
  constructor(
    private appStateService: AppStateService,
    public  commonUtils: CommonUtils,
    private authService: AuthService,
    private storage: Storage
  ) {
    this.initializeApp()
  }

  initializeApp() {
    Network.getStatus().then(status => {
        this.appStateService.updateNetworkStatusSubject(status);
        if (!status.connected) {
          this.appStateService.isOffline.next(true);
        } else {
          this.appStateService.isOffline.next(false);
        }

      Network.addListener('networkStatusChange', (status) => {
        this.appStateService.updateNetworkStatusSubject(status);
        if (!status.connected) {
          this.appStateService.isOffline.next(true);
        } else {
          this.appStateService.isOffline.next(false);
        }
      });
    });
     this.initStorage().then(r =>
       // Sync app state
       this.commonUtils.getStorageObject<UserAuthData>('userAuthData').then((userAuthData) => {
         if (userAuthData && userAuthData.token) {
           this.authService.updateUserAuthData(userAuthData);
         }
       })

     );

  }

  async initStorage() {
    await this.storage.create();
  }


}
